/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetMessagesForEncounterErrorResponse,
  GetMessagesForEncounterResponse,
} from './api.schemas';

import { api } from '../util/http';

export const getEncountersMessages = (encounterId: number, signal?: AbortSignal) => {
  return api<GetMessagesForEncounterResponse>({
    url: `/api/encounters/${encounterId}/messages`,
    method: 'GET',
    signal,
  });
};

export const getGetEncountersMessagesQueryKey = (encounterId?: number) => {
  return [`/api/encounters/${encounterId}/messages`] as const;
};

export const getGetEncountersMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getEncountersMessages>>,
  TError = GetMessagesForEncounterErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersMessages>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEncountersMessagesQueryKey(encounterId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEncountersMessages>>> = ({ signal }) =>
    getEncountersMessages(encounterId, signal);

  return { queryKey, queryFn, enabled: !!encounterId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEncountersMessages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEncountersMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEncountersMessages>>
>;
export type GetEncountersMessagesQueryError = GetMessagesForEncounterErrorResponse;

export function useGetEncountersMessages<
  TData = Awaited<ReturnType<typeof getEncountersMessages>>,
  TError = GetMessagesForEncounterErrorResponse,
>(
  encounterId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersMessages>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersMessages>>,
          TError,
          Awaited<ReturnType<typeof getEncountersMessages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersMessages<
  TData = Awaited<ReturnType<typeof getEncountersMessages>>,
  TError = GetMessagesForEncounterErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersMessages>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersMessages>>,
          TError,
          Awaited<ReturnType<typeof getEncountersMessages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersMessages<
  TData = Awaited<ReturnType<typeof getEncountersMessages>>,
  TError = GetMessagesForEncounterErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersMessages>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEncountersMessages<
  TData = Awaited<ReturnType<typeof getEncountersMessages>>,
  TError = GetMessagesForEncounterErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersMessages>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEncountersMessagesQueryOptions(encounterId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
